import { isDateFuture } from '../../../../utils/dateFunctions';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getNowDateOrEarlierMessage,
    getNumMinMessage,
    getReqMessage,
    getSelectMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

export const MIN_BLOOD_PRESSURE = 10;
export const RANGE_WARNING_CONTENT =
    'Values outside of healthy range, see Contract guidance for Health Incidents.';

export const ranges = {
    systolic: { min: 89, max: 160 },
    diastolic: { min: 59, max: 100 }
};

export const isWarningRange = (systolic, diastolic) => {
    return (
        systolic <= ranges.systolic.min ||
        systolic >= ranges.systolic.max ||
        diastolic <= ranges.diastolic.min ||
        diastolic >= ranges.diastolic.max
    );
};

export const validate = (newEntry, initialRow, formType) => {
    let newErrors = {};

    if (!newEntry.eventDate) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getReqMessage('Event date') }
        };
    } else if (isDateFuture(newEntry.eventDate)) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (!newEntry.systolic) {
        newErrors = {
            ...newErrors,
            systolic: { error: true, message: getReqMessage('Systolic') }
        };
    } else if (newEntry.systolic < MIN_BLOOD_PRESSURE){
        newErrors = {
            ...newErrors,
            systolic: { error: true, message: getNumMinMessage('Systolic', MIN_BLOOD_PRESSURE) }
        };
    }

    if (!newEntry.diastolic) {
        newErrors = {
            ...newErrors,
            diastolic: { error: true, message: getReqMessage('Diastolic') }
        };
    } else if (newEntry.diastolic < MIN_BLOOD_PRESSURE){
        newErrors = {
            ...newErrors,
            diastolic: { error: true, message: getNumMinMessage('Diastolic', MIN_BLOOD_PRESSURE) }
        };
    }

    if (!newEntry.measurementId) {
        newErrors = {
            ...newErrors,
            measurementId: { error: true, message: getSelectMessage('measurement type') }
        };
    }

    if (formType === 'edit' && Object.keys(newErrors).length < 1) {
        newErrors = checkDiff(newEntry, initialRow);
    }

    return newErrors;
};

